import React from 'react'
import { Classes, Card, H6 } from '@blueprintjs/core'
import { Table, PageContent, Button, Flex } from '@ui'
import Appbar from 'components/Appbar'
import { Column } from './ReportPage'
import css from './reportSkeleton.module.scss'

export default function ReportSkeleton() {
  const columns = [
    {
      label: 'Column 1',
      render: (row: number[]) => <div className={Classes.SKELETON}>SOMETHING</div>,
    },
    {
      label: 'Column 2',
      render: (row: number[]) => <div className={Classes.SKELETON}>SOMETHING</div>,
    },
    {
      label: 'Column 3',
      render: (row: number[]) => <div className={Classes.SKELETON}>SOMETHING</div>,
    },
    {
      label: 'Column 4',
      render: (row: number[]) => <div className={Classes.SKELETON}>SOMETHING</div>,
    },
    {
      label: 'Column 5',
      render: (row: number[]) => <div className={Classes.SKELETON}>SOMETHING</div>,
    },
    {
      label: 'Column 6',
      render: (row: number[]) => <div className={Classes.SKELETON}>SOMETHING</div>,
    },
  ]

  const data = [{ id: '0' }, { id: '1' }, { id: '2' }, { id: '3' }, { id: '4' }, { id: '5' }]

  return (
    <>
      <Appbar loading title="LOADING" />
      <PageContent>
        <div style={{ height: 158, width: '100%', marginBottom: 14 }}>
          <div style={{ padding: '10px 0px' }}>
            <Button text="Filter" iconName="filter" />
          </div>
          <div className={css.filters_container}>
            <div className={css.mock_filter}>
              <H6 className={Classes.SKELETON}>SOMETHING SOMETHING</H6>
              <div style={{ margin: 10, height: 30 }} className={Classes.SKELETON}>
                SOMETHING SOMETHING SOMETHING
              </div>
            </div>
            <div className={css.mock_filter}>
              <H6 className={Classes.SKELETON}>SOMETHING SOMETHING</H6>
              <div style={{ margin: 10, height: 30 }} className={Classes.SKELETON}>
                SOMETHING SOMETHING SOMETHING
              </div>
            </div>
            <div className={css.mock_filter}>
              <H6 className={Classes.SKELETON}>SOMETHING SOMETHING</H6>
              <div style={{ margin: 10, height: 30 }} className={Classes.SKELETON}>
                SOMETHING SOMETHING SOMETHING
              </div>
            </div>
            <div className={css.mock_filter}>
              <H6 className={Classes.SKELETON}>SOMETHING SOMETHING</H6>
              <div style={{ margin: 10, height: 30 }} className={Classes.SKELETON}>
                SOMETHING SOMETHING SOMETHING
              </div>
            </div>
          </div>
        </div>
        <Flex>
          <Column>
            <Card style={{ height: '100%', width: '100%' }}>
              <H6 className={Classes.SKELETON}>SOMETHING</H6>
              <div style={{ height: 300, marginTop: 32 }} className={Classes.SKELETON} />
            </Card>
          </Column>
          <Column>
            <Card style={{ height: '100%', width: '100%' }}>
              <H6 className={Classes.SKELETON}>SOMETHING</H6>
              <div style={{ height: 300, marginTop: 32 }} className={Classes.SKELETON} />
            </Card>
          </Column>
          <Column>
            <Card style={{ height: '100%', width: '100%' }}>
              <H6 className={Classes.SKELETON}>SOMETHING</H6>
              <div style={{ height: 300, marginTop: 32 }} className={Classes.SKELETON} />
            </Card>
          </Column>
        </Flex>
        <Table isLoading columns={columns} data={data} />
      </PageContent>
    </>
  )
}
